import React, { useEffect, useState } from "react";
import BulkActionsProvider from "shared/context/BulkActionsProvider";
import {
    Modal,
    Notification,
    STATUS_TYPES,
    TableWithHeader,
} from "dyl-components";
import Toolbar from "./subcomponents/Toolbar";
import Table from "./subcomponents/Table";
import useModal from "utils/useModal";
import "./index.scss";
import {
    KEY_CREATED_BY,
    KEY_ACTIONS,
    KEY_CATEGORY_NAME,
    KEY_DESCRIPTION,
    KEY_TAGGED_CALLS,
} from "./contants";
import AddEditForm from "./subcomponents/AddEditForm";
import { useDispatch } from "react-redux";
import tagsCategoryActions from "actions/tag_categories";
import FullScreenModalPopUp from "shared/FullScreenModalPopUp";

const defaultColumns = [
    KEY_CREATED_BY,
    KEY_ACTIONS,
    KEY_CATEGORY_NAME,
    KEY_DESCRIPTION,
    KEY_TAGGED_CALLS,
];
const isColumnHidden = (column) => {
    return !defaultColumns.includes(column);
};

const Tags = () => {
    const dispatch = useDispatch();
    const addEditModal = useModal(),
        unsavedChangesConfirmationModal = useModal();
    const [isFormDirty, setIsFormDirty] = useState(false);

    const onDelete = async (callTag) => {
        try {
            await dispatch(tagsCategoryActions.deleteTagCategory(callTag?.id));
            Notification.alert(
                "Tag Category deleted successfully",
                STATUS_TYPES.SUCCESS
            );
            await dispatch(tagsCategoryActions.getListOfTagCategories());
        } catch (error) {
            console.error(error);
            Notification.alert("Something went wrong", STATUS_TYPES.ERROR);
        }
    };

    const onEdit = (callTag) => {
        addEditModal?.openModal(callTag);
    };

    useEffect(() => {
        dispatch(tagsCategoryActions.getListOfTagCategories());
    }, [dispatch]);

    return (
        <React.Fragment>
            <FullScreenModalPopUp
                header={"Changes not saved"}
                subheader={"Are you sure you want to exit?"}
                isOpen={unsavedChangesConfirmationModal?.isVisible}
                onConfirm={() => {
                    addEditModal?.closeModal();
                    unsavedChangesConfirmationModal?.closeModal();
                }}
                onFormClose={unsavedChangesConfirmationModal?.closeModal}
                closeIcon={false}
            />
            <div className="TagsPage">
                <TableWithHeader
                    header={
                        <Toolbar onAddTag={() => addEditModal.openModal()} />
                    }
                    table={
                        <Table
                            isColumnHidden={isColumnHidden}
                            onEdit={onEdit}
                            onDelete={onDelete}
                            onAdd={() => addEditModal.openModal()}
                        />
                    }
                />
            </div>
            <Modal
                open={addEditModal?.isVisible}
                onClose={
                    isFormDirty
                        ? unsavedChangesConfirmationModal?.openModal
                        : addEditModal?.closeModal
                }
            >
                <AddEditForm
                    data={addEditModal?.data}
                    closeModal={addEditModal?.closeModal}
                    setIsFormDirty={setIsFormDirty}
                />
            </Modal>
        </React.Fragment>
    );
};

export default function TagsContainer() {
    return (
        <BulkActionsProvider>
            <Tags />
        </BulkActionsProvider>
    );
}
